import {createSvgIcon} from '../create-svg-icon';

export const ViewSidebarIcon = createSvgIcon(
  <path d="M2 4v16h20V4H2zm18 4.67h-2.5V6H20v2.67zm-2.5 2H20v2.67h-2.5v-2.67zM4 6h11.5v12H4V6zm13.5 12v-2.67H20V18h-2.5z" />
, 'ViewSidebarOutlined');
